import { initPosthog } from './posthog'
import { initSentry } from './sentry'

export function initTelemetry(): void {
  initSentry()
  initPosthog()
}
